import { createSelector } from 'reselect';

export const getIsTextLoading = (state) => state.attachments.pending;

export const getAttachmentsTexts = (state) => state.attachments.texts ?? {};

export const getCurrentAttachmentText = createSelector(
  [getAttachmentsTexts, (state, params) => params],
  (attachmentsTexts = {}, { attachmentId } = {}) =>
    (attachmentId && attachmentsTexts[attachmentId]) ?? ''
);
